import {combineReducers} from 'redux';

import {billingInformationReducer} from './billingInformation/reducer';
import {carAuditReducer} from './carAudit/reducer';
import {catalogueReducer} from './catalogue/reducer';
import {commonReducer} from './common/reducer';
import {documentSeriesReducer} from './documentSeries/reducer';
import {interestSeriesDefinitionReducer} from './interestSeries/reducer';
import {UserManagementReducer} from './userManagement/reducer';
import {vehicleCatalogueReducer} from './vehicleCatalogue/reducer';
import {vehicleSettingsReducer} from './vehicleSettings/reducer';

export const teasReducers = {
  common: commonReducer,
  catalogue: catalogueReducer,
  vehicleCatalogue: vehicleCatalogueReducer,
  generalSettings: combineReducers({
    userManagement: UserManagementReducer,
    billingInformation: billingInformationReducer,
    documentSeries: documentSeriesReducer,
    vehicleSettings: vehicleSettingsReducer,
    interestSettings: combineReducers({
      interestSeriesDefinition: interestSeriesDefinitionReducer,
    }),
  }),
  carAudit: carAuditReducer,
};

const reducers = combineReducers({...teasReducers});
export type TeasReducers = typeof reducers;
